import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { HeroSection } from '../components/HeroSection';
import { ValuePropsSection } from '../components/ValuePropsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { WhyChooseSection } from '../components/WhyChooseSection';
import { IdealClientsSection } from '../components/IdealClientsSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function HomePage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-216">
      <Navbar data-id="element-217" />
      <HeroSection data-id="element-218" />
      <ValuePropsSection data-id="element-219" />
      <HowItWorksSection data-id="element-220" />
      <WhyChooseSection data-id="element-221" />
      <IdealClientsSection data-id="element-222" />
      <FAQSection data-id="element-223" />
      <FinalCTASection data-id="element-224" />
      <Footer data-id="element-225" />
    </div>;
}